<app-header></app-header>

<div class="wrapper">

  <app-estimate-box [isLoader]="isLoader"
    [submitBtnLabel]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'"
    (submitBtnClick)="saveExteriorData(historyState.isPaymentDone ? 'submit' : 'skip')"
    (forwardClick)="saveExteriorData(null)" (backClick)="back()"></app-estimate-box>

  <div class="section_wrapper" style="margin-top: 20px;">
    <!-- stepper component -->
    <div class="dashBoard exterior_wrap">
      <app-stepper currentIndex="1.5" class="stepper"></app-stepper>
      <div class="exterior_details w_100">
        <div class="exterior_details_form">
          <h3 class="font_40_a32">Exterior</h3>
          <div class=" form_section">

            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Architectural Style</mat-label>
              <input matInput placeholder="" name="" [(ngModel)]="ArchitecturalStyle" maxlength=50>

            </mat-form-field>

            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Pool Features</mat-label>
              <mat-chip-grid #chipGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let PoolFeatureitems of PoolFeatures"
                  (removed)="removePoolFeatures(PoolFeatureitems)">
                  {{PoolFeatureitems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + PoolFeatureitems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #poolFeatureInput [formControl]="poolCtrl" [matChipInputFor]="chipGrid"
                [matAutocomplete]="autopoolFeature" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addPoolFeatures($event)" />
              <mat-autocomplete #autopoolFeature="matAutocomplete" (optionSelected)="selectedPoolFeatures($event)">
                <mat-option *ngFor="let item of filteredPoolFeatures | async" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Patio or Porch</mat-label>
              <mat-chip-grid #chipGridPorch aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let PorchFeatureitems of PatioAndPorchFeatures"
                  (removed)="removePorchFeatures(PorchFeatureitems)">
                  {{PorchFeatureitems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + PorchFeatureitems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #porchFeatureInput [formControl]="porchCtrl" [matChipInputFor]="chipGridPorch"
                [matAutocomplete]="autoPorchFeature" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addPorchFeatures($event)" />
              <mat-autocomplete #autoPorchFeature="matAutocomplete" (optionSelected)="selectedPorchFeatures($event)">
                <mat-option *ngFor="let item of filteredPorchFeatures | async" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>


            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Fencing</mat-label>
              <mat-chip-grid #chipGridFencing aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let fencingItems of Fencing" (removed)="removeFence(fencingItems)">
                  {{fencingItems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + fencingItems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #fenceInput [formControl]="fenceCtrl" [matChipInputFor]="chipGridFencing"
                [matAutocomplete]="autoFence" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addFence($event)" />
              <mat-autocomplete #autoFence="matAutocomplete" (optionSelected)="selectedFence($event)">
                <mat-option *ngFor="let item of filteredFence | async" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>


            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Exterior Features</mat-label>
              <mat-chip-grid #chipGridExterior aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let exteriorItems of ExteriorFeatures"
                  (removed)="removeExteriorFeatures(exteriorItems)">
                  {{exteriorItems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + exteriorItems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #exteriorFeatureInput [formControl]="exteriorCtrl"
                [matChipInputFor]="chipGridExterior" [matAutocomplete]="autoExterior"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addExteriorFeatures($event)" />
              <mat-autocomplete #autoExterior="matAutocomplete" (optionSelected)="selectedExteriorFeatures($event)">
                <mat-option *ngFor="let item of filteredExteriorFeatures | async" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

          </div>

          <!-- <div class="submit_buttons">
            <p class="save_text" *ngIf="historyState.exteriorData">
              <span class="check_icon"><img src="../../../assets/icons/check_green.svg" alt="done"></span>
              Saved
            </p>

            <div class="buttons">

              <button class="back_button" *ngIf="!isLoader" (click)="saveExteriorData()">Next</button>

              <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

              <app-green-button-v2 (click)="saveExteriorData('skip')" label="Choose Plan"
                *ngIf="!isLoader && !historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

              <app-green-button-v2 (click)="saveExteriorData('submit')" label="Submit Listing"
                *ngIf="!isLoader && historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

            </div>
          </div> -->

          <div class="mobile_submitButtons">
            <button class="arrowBtn leftArrow" (click)="back()">
              <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
            </button>
            <app-green-button-v2 class="SumbitBtnRes"
              (click)="saveExteriorData(historyState.isPaymentDone ? 'submit' : 'skip')"
              [label]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'" [buttonType]="'submit'"
              [width]="'136px'" [height]="'50px'">
            </app-green-button-v2>
            <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
            <button (click)="saveExteriorData(null)" class="arrowBtn rightArrow">
              <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>